import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { wantToOpenInNewTab } from '../../../../../utils/linkUtils';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { ResultsType } from '../../../../state/reducers/results.types';
import { AnimatedLink } from '../../../../../components/animated-link/AnimatedLink';
import { RestrictedModalCommentaries } from '../../../../../components/modal/components/modal-restricted/RestrictedModalCommentaries';
import { useModal } from '../../../../../components/modal/useModal';
import { UserContext } from '../../../../../user/UserContext';
import './search_commentary_snippet.scss';

type Props = {
  commentaries: NonNullable<ResultsType['snippets']['commentaries']>;
  query: string;
  onSeeMore: Function;
};

export const SearchCommentarySnippetSeeMore: FC<Props> = ({
  onSeeMore,
  query,
}) => {
  const { accessPremium } = useContext(UserContext);
  const { openModal } = useModal(modalProps => (
    <RestrictedModalCommentaries
      source="commentary-snippet-see-more"
      {...modalProps}
    />
  ));

  const reportSeeMore = () => {
    doctrineAnalytics('Search TypeOfResultChanged', {
      type: 'commentary',
      source: 'commentaries_snippet',
    });
  };

  const seeMoreMouseDown = (event: {
    nativeEvent: MouseEvent & { which: number };
  }) => {
    if (event.nativeEvent.which === 2) {
      reportSeeMore();
    }
  };

  const seeMore = (event: React.MouseEvent<HTMLAnchorElement>) => {
    reportSeeMore();
    if (!wantToOpenInNewTab(event)) {
      event.preventDefault();
      event.stopPropagation();
      onSeeMore();
    }
  };

  const linkProps = accessPremium
    ? {
        href: buildUrlWithParameters('/search', {
          q: query,
          type: 'commentary',
          source: 'commentary-snippet',
        }),
        onMouseDown: seeMoreMouseDown,
        onClick: seeMore,
      }
    : {
        onClick: openModal,
      };

  return (
    <div className="search-commentary-snippet__see-more">
      <AnimatedLink {...linkProps}>
        <FormattedMessage id="search/components/search-snippets/main/commentary/SearchCommentarySnippet.tsx/1" />
      </AnimatedLink>
    </div>
  );
};
